export const sounds = [
  {
    "text": "Always been a Pirate",
    "sound": "/sounds/Always_been_a_Pirate.ogg"
  },
  {
    "text": "Ass Goblin",
    "sound": "/sounds/Ass_Goblin.ogg"
  },
  {
    "text": "Asshole",
    "sound": "/sounds/Asshole.ogg"
  },
  {
    "text": "Billions are Coming",
    "sound": "/sounds/Billions_are_Coming.ogg"
  },
  {
    "text": "Bitcoin is my Eyes",
    "sound": "/sounds/Bitcoin_is_my_Eyes.ogg"
  },
  {
    "text": "Bitcoin is my Kidney",
    "sound": "/sounds/Bitcoin_is_my_Kidney.ogg"
  },
  {
    "text": "Bitcoin is my Leg",
    "sound": "/sounds/Bitcoin_is_my_Leg.ogg"
  },
  {
    "text": "Bitcoin is my Life",
    "sound": "/sounds/Bitcoin_is_my_Life.ogg"
  },
  {
    "text": "Bitcoin is my Liver",
    "sound": "/sounds/Bitcoin_is_my_Liver.ogg"
  },
  {
    "text": "Bitcoin is my Stomach",
    "sound": "/sounds/Bitcoin_is_my_Stomach.ogg"
  },
  {
    "text": "Bush did ",
    "sound": "/sounds/Bush_did_911.ogg"
  },
  {
    "text": "Choo Choo Niggas",
    "sound": "/sounds/Choo_Choo_Niggas.ogg"
  },
  {
    "text": "Dont Coom",
    "sound": "/sounds/Dont_Coom.ogg"
  },
  {
    "text": "Fuck the broke Niggas",
    "sound": "/sounds/Fuck_the_broke_Niggas.ogg"
  },
  {
    "text": "Giant Paggot",
    "sound": "/sounds/Giant_Paggot.ogg"
  },
  {
    "text": "Go Go Go do It",
    "sound": "/sounds/Go_Go_Go_do_It.ogg"
  },
  {
    "text": "Hagga hagga Yagga",
    "sound": "/sounds/Hagga_hagga_Yagga.ogg"
  },
  {
    "text": "I am Cocksucker",
    "sound": "/sounds/I_am_Cocksucker.ogg"
  },
  {
    "text": "I am Mrs Doubtfire",
    "sound": "/sounds/I_am_Mrs_Doubtfire.ogg"
  },
  {
    "text": "I am a massive Knobjockey",
    "sound": "/sounds/I_am_a_massive_Knobjockey.ogg"
  },
  {
    "text": "I am gigantic Ballticker",
    "sound": "/sounds/I_am_gigantic_Ballticker.ogg"
  },
  {
    "text": "I am intergalactic bellend licker",
    "sound": "/sounds/I_am_intergalactic_bellend_licker.ogg"
  },
  {
    "text": "I am the Bitcoins Obama",
    "sound": "/sounds/I_am_the_Bitcoins_Obama.ogg"
  },
  {
    "text": "I am the Egregore",
    "sound": "/sounds/I_am_the_Egregore.ogg"
  },
  {
    "text": "I am the Pirate Haggayagga",
    "sound": "/sounds/I_am_the_Pirate_Haggayagga.ogg"
  },
  {
    "text": "I am the Powerful Man",
    "sound": "/sounds/I_am_the_Powerful_Man.ogg"
  },
  {
    "text": "I am the Serious Man",
    "sound": "/sounds/I_am_the_Serious_Man.ogg"
  },
  {
    "text": "I am the Tranny",
    "sound": "/sounds/I_am_the_Tranny.ogg"
  },
  {
    "text": "I dont want a tranny fanny",
    "sound": "/sounds/I_dont_want_a_tranny_fanny.ogg"
  },
  {
    "text": "I hate a jeet in Life",
    "sound": "/sounds/I_hate_a_jeet_in_Life.ogg"
  },
  {
    "text": "I hate all Shitcoins",
    "sound": "/sounds/I_hate_all_Shitcoins.ogg"
  },
  {
    "text": "I never coom in Life",
    "sound": "/sounds/I_never_coom_in_Life.ogg"
  },
  {
    "text": "I never ever going Back",
    "sound": "/sounds/I_never_ever_going_Back.ogg"
  },
  {
    "text": "I will not Sleep",
    "sound": "/sounds/I_will_not_Sleep.ogg"
  },
  {
    "text": "Induce Me",
    "sound": "/sounds/Induce_Me.ogg"
  },
  {
    "text": "Intergalactic bellend Licker",
    "sound": "/sounds/Intergalactic_bellend_Licker.ogg"
  },
  {
    "text": "Massive Paggot",
    "sound": "/sounds/Massive_Paggot.ogg"
  },
  {
    "text": "Massive knob Jockey",
    "sound": "/sounds/Massive_knob_Jockey.ogg"
  },
  {
    "text": "Moooooon for the Bitcoiiiins",
    "sound": "/sounds/Moooooon_for_the_Bitcoiiiins.ogg"
  },
  {
    "text": "Paggot",
    "sound": "/sounds/Paggot1.ogg"
  },
  {
    "text": "Paggot",
    "sound": "/sounds/Paggot2.ogg"
  },
  {
    "text": "Paggot",
    "sound": "/sounds/Paggot3.ogg"
  },
  {
    "text": "Paggot",
    "sound": "/sounds/Paggot4.ogg"
  },
  {
    "text": "President of Nigeria",
    "sound": "/sounds/President_of_Nigeria.ogg"
  },
  {
    "text": "Sailors fuck my Ass",
    "sound": "/sounds/Sailors_fuck_my_Ass.ogg"
  },
  {
    "text": "Scallywags",
    "sound": "/sounds/Scallywags.ogg"
  },
  {
    "text": "Shiver me Timbers",
    "sound": "/sounds/Shiver_me_Timbers.ogg"
  },
  {
    "text": "Strangest Man",
    "sound": "/sounds/Strangest_Man.ogg"
  },
  {
    "text": "Support induce Me",
    "sound": "/sounds/Support_induce_Me.ogg"
  },
  {
    "text": "Thank You",
    "sound": "/sounds/Thank_You.ogg"
  },
  {
    "text": "Thank you for loving Me",
    "sound": "/sounds/Thank_you_for_loving_Me.ogg"
  },
  {
    "text": "Ticker Bitcoins",
    "sound": "/sounds/Ticker_Bitcoins.ogg"
  },
  {
    "text": "What is your Questions",
    "sound": "/sounds/What_is_your_Questions.ogg"
  },
  {
    "text": "Wut u say Bro",
    "sound": "/sounds/Wut_u_say_Bro.ogg"
  }
];